import React from 'react';
import { Accounting } from '../../../../firebase/accountingFirestoreService';
import { formatCurrency } from '../../../../utils/formatCurrency';

interface RecentTransactionsTableProps {
  transactions: Accounting[];
}

const RecentTransactionsTable: React.FC<RecentTransactionsTableProps> = ({ transactions }) => {
  return (
    <div className="bg-white rounded-xl shadow-soft p-2 border border-gray-100">
      <h4 className="text-sm font-medium text-gray-900 mb-2">Recent Transactions</h4>
      <div className="overflow-x-auto">
        <table className="min-w-full text-xs text-left">
          <thead>
            <tr className="text-[10px] text-gray-500 uppercase">
              <th className="px-2 py-1">ID</th>
              <th className="px-2 py-1">Date</th>
              <th className="px-2 py-1">Vendor</th>
              <th className="px-2 py-1">Category</th>
              <th className="px-2 py-1 text-right">Amount</th>
              <th className="px-2 py-1">Status</th>
            </tr>
          </thead>
          <tbody>
            {transactions.length === 0 ? (
              <tr>
                <td colSpan={6} className="px-2 py-2 text-center text-gray-500 text-xs">No recent transactions</td>
              </tr>
            ) : (
              transactions.map((t) => (
                <tr key={t.accountingId} className="border-t">
                  <td className="px-2 py-1">#{t.accountingId}</td>
                  <td className="px-2 py-1">{new Date(t.date).toLocaleDateString()}</td>
                  <td className="px-2 py-1">{t.vendor || '-'}</td>
                  <td className="px-2 py-1">{t.category}</td>
                  <td className="px-2 py-1 text-right">{formatCurrency(Math.abs(t.amount))}</td>
                  <td className="px-2 py-1">{t.status}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentTransactionsTable;